import React, { useState } from 'react';
import { Typography, Container, TextField, Button, Box, Alert, CircularProgress } from '@mui/material';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  React.useEffect(() => {
    document.title = 'My Store - Contact Us';
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await fetch('https://h6xdhi3wnptpc2wqpmja7vdoba0eoqvp.lambda-url.us-east-1.on.aws/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message
        })
      });

      if (response.ok) {
        setStatus({ type: 'success', message: 'Message sent successfully! We\'ll get back to you soon.' });
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus({ type: 'error', message: 'Failed to send message. Please try again.' });
      }
    } catch (error) {
      setStatus({ type: 'error', message: 'An error occurred. Please try again later.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Typography variant="h4" component="h1" gutterBottom>
        Contact Us
      </Typography>
      
      {status.message && (
        <Alert severity={status.type} sx={{ mb: 2 }}>
          {status.message}
        </Alert>
      )}

      <Box component="form" onSubmit={handleSubmit} noValidate autoComplete="off">
        <TextField 
          fullWidth 
          label="Name" 
          name="name"
          value={formData.name}
          onChange={handleChange}
          margin="normal" 
          required
        />
        <TextField 
          fullWidth 
          label="Email" 
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          margin="normal" 
          required
        />
        <TextField 
          fullWidth 
          label="Message" 
          name="message"
          value={formData.message}
          onChange={handleChange}
          multiline 
          rows={4} 
          margin="normal" 
          required
        />
        <Button 
          type="submit"
          variant="contained" 
          color="primary" 
          sx={{ mt: 2 }}
          disabled={loading || !formData.name || !formData.email || !formData.message}
        >
          {loading ? <CircularProgress size={24} /> : 'Send Message'}
        </Button>
      </Box>
    </Container>
  );
};

export default Contact;